import ApiRequestManagerInstance from '../ApiRequestManager';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { IRailsRequest, IRailShow } from '../../types/interfaces/rail';

function searchReelsRequest() {
  const promise = new Promise<Rail[]>(async (resolve) => {
    try {
      const response: IRailsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: 'carrier',
          type: 'searchReels',
          replacement: TranslationManager.currentLanguage,
        },
      })) as unknown as IRailsRequest;
      let rails: Rail[] = [];
      if (response?.data?.length) {
        rails = response.data?.sort((item, item2)=>(item.section?.position || -1) - (item2.section?.position || -1)).map((item) => {
          if (item.shows) {
            item.shows.data = item.shows as unknown as IRailShow[];
          }
          return new Rail(item);
        });
      }
      resolve(rails);
    } catch (e) {
      console.error(e);
      resolve([]);
    }
  });

  return promise;
}

export default searchReelsRequest;
